import { createIcon } from '@chakra-ui/icons';

export const NavShare = createIcon({
  displayName: 'Share',
  viewBox: '0 0 12 12',
  d: 'M0.00666666 12L14 6L0.00666666 0L0 4.66667L10 6L0 7.33333L0.00666666 12Z',
});
